export const nameReducer = 'CUtranslations';
